// src/common/data/getTypeCategoryFromDisplay.ts

import { ITEM_TYPES } from './itemTypes3';

/**
 * Maps a type_label_display (e.g., "Jeans") to its corresponding type_category (e.g., "Bottom").
 */
export const getTypeCategoryFromDisplay = (
  labelDisplay: string
): {
  raw: string | null;
} => {
  const match = ITEM_TYPES.find(
    (item) => item.type_label_display === labelDisplay
  );

  return {
    raw: match?.type_category ?? null,
  };
};
